import * as React from 'react';
import { MouseEventHandler } from 'react';
import { css, SerializedStyles } from '@emotion/core';
import LocalDiv from '../localization/LocalDiv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import Spacer from './Spacer';
import Msg from '../localization/Msg';


const styles = {
  root:   css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  spacer: css`
    margin: 0;
  `,
};

type Props = {
  icon: IconDefinition;
  msg: string | number;
  spacePx?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  iconStyle?: SerializedStyles;
  role?: string;
  className?: string;
};


/**
 * BulletedMsg: a component that renders a localized bullet point -- basically. It's a FontAwesome image next to some
 * text, and the direction is set from the current locale.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const BulletedMsg: React.FC<Props> = props => (
  <LocalDiv
    role={props.role}
    onClick={props.onClick}
    css={styles.root}
    className={props.className}
  >
    <FontAwesomeIcon icon={props.icon} css={props.iconStyle} />
    <Spacer sizePx={props.spacePx!} css={styles.spacer} />
    <Msg str={props.msg} defaultMsg={props.msg} />
  </LocalDiv>
);

BulletedMsg.defaultProps = {
  spacePx: 5,
};

export default BulletedMsg;
